module.exports = __webpack_public_path__ + "img/talron-wrench.46893f5c.svg";